module.exports = __webpack_public_path__ + "static/Snake_Winged-73c58c293055d632e77ef476f142c9fc.jpg";